export * from "./IPopUp";
//# sourceMappingURL=index.js.map